module.exports = __webpack_public_path__ + "static/instax.5cb47357.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/instax.png
// module id = 3134
// module chunks = 174994552580003